import React, { useState } from "react";

const EmpPersonalDetails = ({ data, setData, errors = {} }) => {
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: files ? files[0] : value,
        }));
    };

    return (
        <>



            <div className="row g-3">
                <div className="col-lg-4">
                    <label className="form-label">User Name <span className="danger">*</span></label>
                    <input
                        name="username"
                        className="form-control"
                        value={data.username || ""}
                        onChange={handleChange}
                    />
                    {errors.username && <small className="error-text">{errors.username}</small>}
                </div>
                    <div className="col-lg-4">
                        <label className="form-label">Password <span className="danger">*</span></label>
                        <input
                            name="password"
                            className="form-control"
                            value={data.password || ""}
                            onChange={handleChange}
                        />
                        {errors.password && <small className="error-text">{errors.password}</small>}
                    </div>
             
                <div className="col-lg-4">
                    <label className="form-label">Employee ID <span className="danger">*</span></label>
                    <input
                        name="employeeId"
                        className="form-control"
                        value={data.employeeId || ""}
                        onChange={handleChange}
                    />
                    {errors.employeeId && <small className="error-text">{errors.employeeId}</small>}
                </div>

                <div className="col-lg-4">
                    <label className="form-label">Salutation <span className="danger">*</span></label>
                    <select
                        name="salutation"
                        className="form-select"
                        value={data.salutation || ""}
                        onChange={handleChange}
                    >
                        <option value="">Select</option>
                        <option>Mr</option>
                        <option>Miss</option>
                        <option>Mrs</option>
                    </select>
                    {errors.salutation && <small className="error-text">{errors.salutation}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">First Name <span className="danger">*</span></label>
                    <input
                        name="firstName"
                        className="form-control"
                        value={data.firstName || ""}
                        onChange={handleChange}
                    />
                    {errors.firstName && <small className="error-text">{errors.firstName}</small>}
                </div>
                <div className="col-lg-4">
                    <label className="form-label">Last Name <span className="danger">*</span></label>
                    <input
                        name="lastName"
                        className="form-control"
                        value={data.lastName || ""}
                        onChange={handleChange}
                    />
                    {errors.lastName && <small className="error-text">{errors.lastName}</small>}

                </div>

                <div className="col-lg-4">
                    <label className="form-label">Gender <span className="danger">*</span></label>
                    <select
                        name="gender"
                        className="form-select"
                        value={data.gender || ""}
                        onChange={handleChange}
                    >
                        <option value="">Select</option>
                        <option>Male</option>
                        <option>Female</option>
                        <option>Other</option>
                    </select>
                    {errors.gender && <small className="error-text">{errors.gender}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Date of Birth <span className="danger">*</span></label>
                    <input
                        type="date"
                        name="dob"
                        className="form-control"
                        value={data.dob || ""}
                        onChange={handleChange}
                    />
                    {errors.dob && <small className="error-text">{errors.dob}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Age <span className="danger">*</span></label>
                    <input
                        name="age"
                        className="form-control"
                        value={data.age || ""}
                        onChange={handleChange}
                    />
                    {errors.age && <small className="error-text">{errors.age}</small>}

                </div>
                <div className="border_">
                    <span className="border-line"></span>
                </div>
                <div className="col-lg-4">
                    <label className="form-label">Blood Group <span className="danger">*</span></label>
                    <input
                        name="bloodgroup"
                        className="form-control"
                        value={data.bloodgroup || ""}
                        onChange={handleChange}
                    />
                    {errors.bloodgroup && <small className="error-text">{errors.bloodgroup}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Martial Status <span className="danger">*</span></label>
                    <input
                        name="martialstatus"
                        className="form-control"
                        value={data.martialstatus || ""}
                        onChange={handleChange}
                    />
                    {errors.martialstatus && <small className="error-text">{errors.martialstatus}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Present Address <span className="danger">*</span></label>
                    <input
                        name="presentaddress"
                        className="form-control"
                        value={data.presentaddress || ""}
                        onChange={handleChange}
                    />
                    {errors.presentaddress && <small className="error-text">{errors.presentaddress}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Permanent Address <span className="danger">*</span></label>
                    <input
                        name="permanentaddress"
                        className="form-control"
                        value={data.permanentaddress || ""}
                        onChange={handleChange}
                    />
                    {errors.permanentaddress && <small className="error-text">{errors.permanentaddress}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Father Name <span className="danger">*</span></label>
                    <input
                        name="fathername"
                        className="form-control"
                        value={data.fathername || ""}
                        onChange={handleChange}
                    />
                    {errors.fathername && <small className="error-text">{errors.fathername}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Mother Name <span className="danger">*</span></label>
                    <input
                        name="mothername"
                        className="form-control"
                        value={data.mothername || ""}
                        onChange={handleChange}
                    />
                    {errors.mothername && <small className="error-text">{errors.mothername}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Mobile Number<span className="danger">*</span></label>
                    <input
                        name="mobilenumber"
                        className="form-control"
                        value={data.mobilenumber || ""}
                        onChange={handleChange}
                    />
                    {errors.mobilenumber && <small className="error-text">{errors.mobilenumber}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Aadhar Number<span className="danger">*</span></label>
                    <input
                        name="aadharnumber"
                        className="form-control"
                        value={data.aadharnumber || ""}
                        onChange={handleChange}
                    />
                    {errors.aadharnumber && <small className="error-text">{errors.aadharnumber}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">PAN Number<span className="danger">*</span></label>
                    <input
                        name="pannumber"
                        className="form-control"
                        value={data.pannumber || ""}
                        onChange={handleChange}
                    />
                    {errors.pannumber && <small className="error-text">{errors.pannumber}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">UAN Number<span className="danger">*</span></label>
                    <input
                        name="uannumber"
                        className="form-control"
                        value={data.uannumber || ""}
                        onChange={handleChange}
                    />
                    {errors.uannumber && <small className="error-text">{errors.uannumber}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Personal Mail ID<span className="danger">*</span></label>
                    <input
                        name="personalmailid"
                        className="form-control"
                        value={data.personalmailid || ""}
                        onChange={handleChange}
                    />
                    {errors.personalmailid && <small className="error-text">{errors.personalmailid}</small>}

                </div>
                <div className="border_">
                    <span className="border-line"></span>
                </div>
                <div className="col-lg-4">
                    <label className="form-label">Location<span className="danger">*</span></label>
                    <input
                        name="location"
                        className="form-control"
                        value={data.location || ""}
                        onChange={handleChange}
                    />
                    {errors.location && <small className="error-text">{errors.location}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Emergency Contact Number<span className="danger">*</span></label>
                    <input
                        name="emergency"
                        className="form-control"
                        value={data.emergency || ""}
                        onChange={handleChange}
                    />
                    {errors.emergency && <small className="error-text">{errors.emergency}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Official Mail ID<span className="danger">*</span></label>
                    <input
                        name="officialmailid"
                        className="form-control"
                        value={data.officialmailid || ""}
                        onChange={handleChange}
                    />
                    {errors.officialmailid && <small className="error-text">{errors.officialmailid}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Reporting Manager<span className="danger">*</span></label>
                    <input
                        name="reportingmanager"
                        className="form-control"
                        value={data.reportingmanager || ""}
                        onChange={handleChange}
                    />
                    {errors.reportingmanager && <small className="error-text">{errors.reportingmanager}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Designation<span className="danger">*</span></label>
                    <input
                        name="designation"
                        className="form-control"
                        value={data.designation || ""}
                        onChange={handleChange}
                    />
                    {errors.designation && <small className="error-text">{errors.designation}</small>}

                </div>
                <div className="col-lg-4">
                    <label className="form-label">Role<span className="danger">*</span></label>
                    <input
                        name="role"
                        className="form-control"
                        value={data.role || ""}
                        onChange={handleChange}
                    />
                    {errors.role && <small className="error-text">{errors.role}</small>}

                </div>
                {/* <div className="col-lg-4">
                    <label className="form-label">Profile Image<span className="danger">*</span></label>
                    <input
                        type="file"
                        name="profileImage"
                        className="form-control"
                        accept="image/*"
                        onChange={handleChange}
                    />
                    {errors.profileImage && (
                        <small className="error-text">{errors.profileImage}</small>
                    )}
                </div> */}
            </div>


        </>

    );
};

export default EmpPersonalDetails;
